
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand/[...slug]",
      function () {
        return require("private-next-pages/brand/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand/[...slug]"])
      });
    }
  